/* eslint-disable sort-keys */
import { Button, Clickable, H4, IconLockup, P, Section } from '@ahmdigital/ui';
import getOpeningHours from '@ahmdigital/logic/lib/utils/get-opening-hours';
import styled from 'styled-components';

import { LIFE_INSURANCE } from '../../../../models/life-insurance/constants';
import constants from '../../../../ahm-constants';
import PreLineParagraph from '../../components/pre-line-paragraph';

const SectionWithBorder = styled(Section)`
  padding-top: 0;
`;

const getLifeAndIncomeContent = () => {
  const openingHoursKey = constants.AHM_SERVICE_NAME.LIFE_INSURANCE_ZURICH;
  return {
    meta: {
      title: 'Life insurance and income protection claims',
      description:
        'Our life insurance claim process is designed to get your claim settled as quickly as possible, so there’s one less thing for you or your family to worry about.',
    },
    banner: {
      title: 'Make a claim',
      preHeading: 'ahm Life Insurance and Income Protection Insurance',
    },
    body: (
      <SectionWithBorder>
        <H4 variant="marginBottomSpacer9">
          For policies purchased between 1 July 2023 - 31 March 2024 that start with ‘AL’ and policies purchased on or
          after 1 March 2024 and begin with ‘AZ’
        </H4>
        <P>
          You can lodge a claim 24/7 through the online claims form below. You’ll get a dedicated claims consultant from
          the insurer to help you through from start to finish.
        </P>
        <P>
          <Button
            to={constants.URLS.THIRD_PARTY.LIFE_INSURANCE_CLAIM_REQUEST_FORM}
            variant={['border', 'transparentBlack']}
          >
            Lodge a claim online
          </Button>
        </P>
        <P>If you would prefer to speak to one of our agents or send an email regarding a claim:</P>
        <IconLockup icon={{ name: 'phone-circle' }}>
          <P looksLike="h4">
            <Clickable to={`tel:${LIFE_INSURANCE.NEOS.CONTACT.PHONE.CLAIMS.STANDARD}`}>
              {LIFE_INSURANCE.NEOS.CONTACT.PHONE.CLAIMS.PRETTY}
            </Clickable>
          </P>
          <PreLineParagraph>{getOpeningHours(openingHoursKey)}</PreLineParagraph>
        </IconLockup>
        <br />
        <IconLockup icon={{ name: 'device-desktop' }}>
          <P looksLike="h4">Email</P>
          <P>
            <Clickable to="mailto:claims@ahmlife.com.au">claims@ahmlife.com.au</Clickable>
          </P>
        </IconLockup>
        <br />
        Further information about making a claim can be found in the relevant Product Disclosure Statements on the{' '}
        <Clickable to={constants.URLS.SALES.LIFE_INSURANCE_USEFUL_DOCUMENTS}>Forms and Guides page.</Clickable>
      </SectionWithBorder>
    ),
    thingsYouShouldKnow: (
      <>
        <P>
          Any advice provided is general only and doesn’t consider your objectives, financial situation or needs. You
          should carefully read the relevant{' '}
          <Clickable to={constants.URLS.SALES.LIFE_INSURANCE_USEFUL_DOCUMENTS} inNewTab>
            Product Disclosure Statement
          </Clickable>{' '}
          (which sets out the product terms, conditions and exclusions),{' '}
          <Clickable to={constants.URLS.SALES.LIFE_INSURANCE_USEFUL_DOCUMENTS} inNewTab>
            Target Market Determination
          </Clickable>{' '}
          and{' '}
          <Clickable to={constants.URLS.SALES.LIFE_INSURANCE_USEFUL_DOCUMENTS} inNewTab>
            Financial Services Guide
          </Clickable>{' '}
          available{' '}
          <Clickable to={constants.URLS.SALES.LIFE_INSURANCE_USEFUL_DOCUMENTS} inNewTab>
            here
          </Clickable>{' '}
          to ensure the product is right for you before making a decision to acquire, or continue to hold, the product.
          ahm Life Insurance and ahm Income Protection (collectively ahm life insurance) are issued by the insurer,
          Integrity Life Australia Limited ABN 83 089 981 073, AFSL 245492 (Integrity Life) administered and distributed
          by NEOS Direct, a registered business name of NDLI Pty Ltd ABN 70 665 747 277 AFSL 547119, and promoted by ahm
          health insurance (ahm), a business of Medibank Private Limited ABN 47 080 890 259. Medibank Private Limited is
          a Corporate Authorised Representative 286089 of NEOS Direct.
        </P>
        <P>
          Your personal information will be handled in accordance with the Privacy Policies of the parties involved.
          Click here for{' '}
          <Clickable to={constants.URLS.THIRD_PARTY.NEOS_PRIVACY_POLICY} inNewTab>
            NEOS Direct’s Privacy Policy
          </Clickable>{' '}
          ,{' '}
          <Clickable to={constants.URLS.SALES.PRIVACY} inNewTab>
            ahm’s Privacy Policy
          </Clickable>{' '}
          or{' '}
          <Clickable to={constants.URLS.THIRD_PARTY.INTEGRITY_LIFE_PRIVACY_POLICY} inNewTab>
            Integrity Life’s Privacy Policy
          </Clickable>
          .
        </P>
      </>
    ),
  };
};

export default getLifeAndIncomeContent;
